import { useCallback } from 'react';

import type { PsfShareChannel } from 'src/app/pages/psf/share/shared/types';

import type { Options } from '../../types';
import { useGetHeadlineVariant } from '../bandits';

import { useGenPetitionUrl } from './genUrl';
import { useGetPetitionShareUrlSuffix } from './pathSuffix';

const MEDIUM_MAPPING: Partial<Record<PsfShareChannel, string>> = {
	facebookMessenger: 'facebook',
	copy: 'copylink',
};

export function useGetShareUrl(): Options['getUrl'] {
	const genUrl = useGenPetitionUrl();
	const getVariant = useGetHeadlineVariant();

	const getDefaultPathSuffix = useGetPetitionShareUrlSuffix();

	return useCallback(
		(channel) => {
			const medium = MEDIUM_MAPPING[channel] || channel;
			const pathSuffix = getDefaultPathSuffix(channel);

			switch (channel) {
				case 'facebook':
				case 'whatsapp':
				case 'copy':
				case 'twitter': {
					const variant = getVariant(channel);
					if (variant) {
						return genUrl({
							medium,
							pathSuffix: variant.pathSuffix,
							additionalParams: variant.urlParameters,
						});
					}
					return genUrl({ medium, pathSuffix });
				}
				default:
					return genUrl({ medium, pathSuffix });
			}
		},
		[genUrl, getDefaultPathSuffix, getVariant],
	);
}
